import { useTranslation } from "react-i18next";

const FaqList = ({ items }) => {
    const { t } = useTranslation();

    return (
        <div className="mt-8">
            <h2 className="text-sm font-semibold text-primary">{t("COMMON_FAQ_TITLE")}</h2>
            <div className="mt-4 space-y-3">
                {items.map((item) => (
                    <div
                        key={item.id || item.question}
                        className="rounded-2xl border border-slate-200 bg-white px-4 py-4 shadow-[0_8px_20px_rgba(15,23,42,0.06)]"
                    >
                        <p className="text-sm font-semibold text-slate-900">{item.question}</p>
                        <p className="mt-2 text-sm text-slate-500">{item.answer}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FaqList;
